import { Injectable } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';

/**
 * Utility class used for save information into Browser session storage
 */
@Injectable({ providedIn: 'root' })
export class StateStorageService {
  private readonly previousUrlKey = 'previousUrl';
  private readonly companyKey = 'company';

  constructor(private readonly $sessionStorage: SessionStorageService) {}

  storeUrl(url: string | null | undefined): void {
    this.$sessionStorage.store(this.previousUrlKey, url);
  }

  getUrl(): string | null | undefined {
    return this.$sessionStorage.retrieve(this.previousUrlKey);
  }

  clearUrl(): void {
    this.$sessionStorage.clear(this.previousUrlKey);
  }

  storeLoggedCompany(company: string): void {
    this.$sessionStorage.store(this.companyKey, company);
  }

  getLoggedCompany(): string {
    return this.$sessionStorage.retrieve(this.companyKey);
  }

  storeCompanyLogoExtension(ext: string): void {
    this.$sessionStorage.store(this.companyKey + '_logoext', ext);
  }

  getCompanyLogoExtension(): string {
    return this.$sessionStorage.retrieve(this.companyKey + '_logoext');
  }

  clearCompany(): void {
    this.$sessionStorage.clear(this.companyKey);
    this.$sessionStorage.clear(this.companyKey + '_logoext');
  }
}
